<mat-dialog-content>
  <p>{{ 'general.motsCle' | translate }}</p>
  <div class="row">
    <div class="col-12">
      <fieldset style="width: 100%;" class="form-group">
        <label for="motCleFr">{{ 'general.fr' | translate }} :</label>
        <input [required]="true" [maxLength]="50"
          id="motCleFr" class="form-control mot-cle-align" placeholder="" [(ngModel)]="motCleFr"
          (ngModelChange)="motCleFr = noPonctuation($event.toUpperCase()); isInList()"
          >
        </fieldset>

        <fieldset style="width: 100%;" class="form-group">
          <label for="motCleEn"> {{ 'general.en' | translate }} :</label>
          <input [required]="true" [maxLength]="50"
            id="motCleEn" class="form-control mot-cle-align" placeholder="" [(ngModel)]="motCleEn"
            (ngModelChange)="motCleEn = noPonctuation($event.toUpperCase()); isInList()">
          </fieldset>

          @if (present) {
            <div class="row alert alert-danger mt-1">
              <div class="col">
                {{'motCles.erreurDoublon' | translate}}
              </div>
            </div>
          }
        </div>
      </div>
    </mat-dialog-content>

    <mat-dialog-actions>
      <button mat-button [mat-dialog-close]="false">{{ 'general.annuler' |translate }}</button>
      <button [disabled]="motCleFr.trim().length === 0 || motCleEn.trim().length === 0 || present" mat-raised-button
      [mat-dialog-close]="{ 'motCleFr' : motCleFr.trim(), 'motCleEn' : motCleEn.trim()}" color="primary" >{{ 'general.valider' | translate }}</button>
    </mat-dialog-actions>
